import { render, staticRenderFns } from "./PlanList.vue?vue&type=template&id=63dac922"
import script from "./PlanList.vue?vue&type=script&lang=ts"
export * from "./PlanList.vue?vue&type=script&lang=ts"
import style0 from "./PlanList.vue?vue&type=style&index=0&id=63dac922&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports